"use client";

import { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose } from "@/components/ui/dialog";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X, ChevronDown, Upload, CircleCheck as CheckCircle2 } from 'lucide-react';
import { toast } from "sonner";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const categories = [{
  category_name: "Estructurales",
  slug: "acero-estructural",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.46-p.m.png?v=au3p67ykc1",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.46-p.m.png?v=s23acuikrbr-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.46-p.m.png?v=nj33vi543an-wvc-sizes"
}, {
  category_name: "Perfileria",
  slug: "laminas-y-placas",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.55-p.m.png?v=ey4gzdzezt",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.55-p.m.png?v=ukpmd7mlehj-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.15.55-p.m.png?v=bwdkxzr0aph-wvc-sizes"
}, {
  category_name: "Planos",
  slug: "perfiles-comerciales",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.01-p.m.png?v=a9d66xbej",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.01-p.m.png?v=70m72w2oz48-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.01-p.m.png?v=xdbnh2fb8j-wvc-sizes"
}, {
  category_name: "Polineria",
  slug: "tuberia",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.07-p.m.png?v=gupmoarjdjo",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.07-p.m.png?v=xh1xjsd806g-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.07-p.m.png?v=f6g0yre00v-wvc-sizes"
}, {
  category_name: "Recubiertos",
  slug: "varilla-y-alambron",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.13-p.m.png?v=vye6qizdai",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.13-p.m.png?v=eqjy931aeev-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.13-p.m.png?v=9szm0ws4v18-wvc-sizes"
}, {
  category_name: "Sólidos",
  slug: "rejillas-y-metal-desplegado",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.18-p.m.png?v=c05egs00a1b",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.18-p.m.png?v=xx8s27gcm7-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.18-p.m.png?v=lmp28vnylm-wvc-sizes"
}, {
  category_name: "Trefilados",
  slug: "herrajes-y-accesorios",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.23-p.m.png?v=8tte6glv7te",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.23-p.m.png?v=ddr9uhueo68-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.23-p.m.png?v=1e0k2u1g3zt-wvc-sizes"
}, {
  category_name: "Tuberia ",
  slug: "servicios-de-corte",
  imageSrc: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.30-p.m.png?v=56etpjgok4s",
  imageSrcset: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.30-p.m.png?v=uw1dgneevmh-wvc-srcset",
  imageSizes: "https://driving-lion-1.10web.cloud/wp-content/uploads/2026/05/Captura-de-pantalla-2026-05-19-a-las-4.16.30-p.m.png?v=sft15ubl8m-wvc-sizes"
}];
const estructuralesProducts = [{
  title: "HSS",
  description: "Perfil tubular rectangular de alta resistencia para estructuras ligeras y marcos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/ptr_product.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/ptr_product.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/ptr_product.png-wvc-sizes",
  link: "/producto/hss"
}, {
  title: "VIGA IPR",
  description: "Vigas de acero estructural for grandes claros and soporte de carga pesada.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr.png-wvc-sizes",
  link: "/producto/viga-ipr"
}, {
  title: "REJILLA IRVING",
  description: "Rejilla electroforjada de alta resistencia para pisos industriales y drenajes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/rejilla_irving.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/rejilla_irving.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/rejilla_irving.png-wvc-sizes",
  link: "/producto/rejilla-irving"
}];
const perfileriaProducts = [{
  title: "PTR",
  description: "Perfil tubular de alta calidad para herrería and estructuras ligeras.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/ptr_standard.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/ptr_standard.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/ptr_standard.png-wvc-sizes",
  link: "/producto/ptr"
}, {
  title: "Perfil Galvanizado",
  description: "Perfiles con recubrimiento de zinc para máxima protección contra la corrosión.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_galvanizado.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_galvanizado.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_galvanizado.png-wvc-sizes",
  link: "/producto/perfil-galvanizado"
}, {
  title: "Perfil Pintado",
  description: "Perfiles con acabado de pintura industrial listos para su instalación estética.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_pintado.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_pintado.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/perfil_pintado.png-wvc-sizes",
  link: "/producto/perfil-pintado"
}];
const planosProducts = [{
  title: 'Lámina negra RC y RF',
  description: 'Lámina de acero rolada en caliente y en frío para diversas aplicaciones industriales.',
  image: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_negra.png',
  srcset: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_negra.png-wvc-srcset',
  sizes: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_negra.png-wvc-sizes',
  link: '/producto/lamina-negra'
}, {
  title: 'Placas de rollo',
  description: 'Placas de acero provenientes de rollo, ideales for procesos de corte y formado.',
  image: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placas_rollo.png',
  srcset: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placas_rollo.png-wvc-srcset',
  sizes: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placas_rollo.png-wvc-sizes',
  link: '/producto/placas-rollo'
}, {
  title: 'Placas de hoja',
  description: 'Placas de acero en hojas individuales con espesores precisos para construcción pesada.',
  image: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placas_hoja.png',
  srcset: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placas_hoja.png-wvc-srcset',
  sizes: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/placas_hoja.png-wvc-sizes',
  link: '/producto/placas-hoja'
}];
const polineriasProducts = [{
  title: "Polín Monten",
  description: "Perfil estructural de acero formado en frío, ideal para cubiertas y fachadas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/polin_monten.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/polin_monten.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/polin_monten.png-wvc-sizes",
  link: "/producto/polin-monten"
}, {
  title: "Polín Z",
  description: "Perfil en forma de Z para traslapes eficientes en estructuras de naves industriales.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/polin_z.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/polin_z.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/polin_z.webp-wvc-sizes",
  link: "/producto/polin-z"
}];
const recubiertosProducts = [{
  title: "Lámina Galvanizada",
  description: "Lámina de acero con recubrimiento de zinc para prevenir la oxidación.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_galvanizada.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_galvanizada.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_galvanizada.png-wvc-sizes",
  link: "/producto/lamina-galvanizada"
}, {
  title: "Lámina Pintro",
  description: "Lámina galvanizada con acabado de pintura de alta resistencia.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_pintro.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_pintro.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_pintro.png-wvc-sizes",
  link: "/producto/lamina-pintro"
}, {
  title: "Lámina Zintro Alum",
  description: "Recubrimiento de aluminio y zinc para mayor durabilidad en ambientes corrosivos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/zintro_alum.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/zintro_alum.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/zintro_alum.png-wvc-sizes",
  link: "/producto/zintro-alum"
}, {
  title: "Lámina Traslúcida",
  description: "Ideal para iluminación natural en naves industriales y bodegas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_traslucida.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_traslucida.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/lamina_traslucida.png-wvc-sizes",
  link: "/producto/lamina-traslucida"
}, {
  title: "Panel Aislante",
  description: "Solución térmica y acústica para muros y cubiertas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/panel_aislante.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/panel_aislante.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/panel_aislante.png-wvc-sizes",
  link: "/producto/panel-aislante"
}];
const solidosProducts = [{
  title: "Cuadrado Macizo",
  description: "Barra de acero de sección cuadrada para aplicaciones estructurales y herrería.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/cuadrado_macizo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/cuadrado_macizo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/cuadrado_macizo.png-wvc-sizes",
  link: "/producto/cuadrado-macizo"
}, {
  title: "Redondo Macizo",
  description: "Barra circular de acero de alta resistencia para diversos usos industriales.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/redondo_macizo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/redondo_macizo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/redondo_macizo.png-wvc-sizes",
  link: "/producto/redondo-macizo"
}, {
  title: "Solera",
  description: "Perfil plano de acero versátil para refuerzos, marcos and soportes.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/solera.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/solera.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/solera.webp-wvc-sizes",
  link: "/producto/solera"
}, {
  title: "Ángulo",
  description: "Perfil en forma de L para estructuras metálicas and soportes de carga.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/angulo.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/angulo.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/angulo.webp-wvc-sizes",
  link: "/producto/angulo"
}, {
  title: "Canal CPS",
  description: "Perfil estructural en forma de U para marcos and soportes de machinery.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/canal_cps.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/canal_cps.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/canal_cps.png-wvc-sizes",
  link: "/producto/canal-cps"
}, {
  title: "Viga IPR",
  description: "Viga de acero de ala ancha para grandes claros en construction pesada.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_solidos.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_solidos.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/viga_ipr_solidos.webp-wvc-sizes",
  link: "/producto/viga-ipr-solidos"
}];
const trefiladosProducts = [{
  title: "Varilla Corrugada",
  description: "Acero de refuerzo para concreto en todo tipo de construcciones.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/varilla_corrugada.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/varilla_corrugada.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/varilla_corrugada.png-wvc-sizes",
  link: "/producto/varilla-corrugada"
}, {
  title: "Alambrón",
  description: "Producto de acero trefilado para la fabricación de estribos y amarres.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambron.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambron.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambron.png-wvc-sizes",
  link: "/producto/alambron"
}, {
  title: "Alambre Recocido",
  description: "Alambre de alta ductilidad para amarres en armados de varilla.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambre_recocido.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambre_recocido.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambre_recocido.png-wvc-sizes",
  link: "/producto/alambre-recocido"
}, {
  title: "Malla Electrosoldada",
  description: "Refuerzo de acero para losas de cimentación and pavimentos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/malla_electrosoldada.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/malla_electrosoldada.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/malla_electrosoldada.png-wvc-sizes",
  link: "/producto/malla-electrosoldada"
}, {
  title: "Armadura (Castillo)",
  description: "Estructura electrosoldada para refuerzo de dalas y castillos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/armadura_castillo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/armadura_castillo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/armadura_castillo.png-wvc-sizes",
  link: "/producto/armadura-castillo"
}, {
  title: "Clavo con Cabeza",
  description: "Clavos de acero de alta resistencia para carpintería y construcción.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/clavo_cabeza.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/clavo_cabeza.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/clavo_cabeza.png-wvc-sizes",
  link: "/producto/clavo-cabeza"
}, {
  title: "Alambre de Púas",
  description: "Solución de seguridad perimetral para cercados agrícolas e industriales.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambre_puas.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambre_puas.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/alambre_puas.png-wvc-sizes",
  link: "/producto/alambre-puas"
}, {
  title: "Malla Ciclónica",
  description: "Tejido de alambre galvanizado para delimitación de áreas y protección.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/malla_ciclonica.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/malla_ciclonica.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/malla_ciclonica.png-wvc-sizes",
  link: "/producto/malla-ciclonica"
}, {
  title: "Grapa para Cerca",
  description: "Fijación resistente para alambre de púas y mallas en postes de madera.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/grapa_cerca.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/grapa_cerca.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/grapa_cerca.png-wvc-sizes",
  link: "/producto/grapa-cerca"
}];
const tuberiaProducts = [{
  title: "Tubería Industrial",
  description: "Tubería de acero de alta precisión para aplicaciones mecánicas and estructurales.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_industrial.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_industrial.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_industrial.png-wvc-sizes",
  link: "/producto/tuberia-industrial"
}, {
  title: "Tubería Cédula 30",
  description: "Tubería ligera para conducción de fluidos a baja presión y herrería.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cedula_30.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cedula_30.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cedula_30.png-wvc-sizes",
  link: "/producto/tuberia-cedula-30"
}, {
  title: "Tubería Cédula 40",
  description: "Tubería de thickness estándar para conducción de agua, gas y vapor.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cedula_40.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cedula_40.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cedula_40.png-wvc-sizes",
  link: "/producto/tuberia-cedula-40"
}, {
  title: "Tubería Galvanizada",
  description: "Tubería con recubrimiento de zinc para máxima resistencia a la corrosión.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_galvanizada.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_galvanizada.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_galvanizada.png-wvc-sizes",
  link: "/producto/tuberia-galvanizada"
}, {
  title: "Tubería Estructural",
  description: "Tubería de grandes dimensiones for support of load in construction.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_estructural.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_estructural.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_estructural.webp-wvc-sizes",
  link: "/producto/tuberia-estructural"
}, {
  title: "Tubería de Cerco",
  description: "Tubería especializada para la instalación de mallas y cercados perimetrales.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cerco.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cerco.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/tuberia_cerco.png-wvc-sizes",
  link: "/producto/tuberia-cerco"
}];
const initialProductSpecifications: Record<string, {
  drawingImage: string;
  backgroundImage: string;
  measurements: {
    label: string;
    value: string;
  }[];
}> = {
  "estructurales_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "estructurales_1": {
    drawingImage: '',
    backgroundImage: 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/Captura de pantalla 2026-06-04 a la(s) 12.03.20 p.m..png',
    measurements: []
  },
  "estructurales_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "perfileria_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "perfileria_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "perfileria_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "planos_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "planos_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "planos_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "polineria_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "polineria_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "recubiertos_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "recubiertos_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "recubiertos_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "recubiertos_3": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "recubiertos_4": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "solidos_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "solidos_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "solidos_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "solidos_3": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "solidos_4": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "solidos_5": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_3": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_4": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_5": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_6": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_7": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "trefilados_8": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "tuberia_0": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "tuberia_1": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "tuberia_2": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "tuberia_3": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "tuberia_4": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  },
  "tuberia_5": {
    drawingImage: '',
    backgroundImage: '',
    measurements: []
  }
};
function SpecificationsConsumer({
  openModalCategory,
  setOpenModalCategory,
  selectedProductSpecs,
  setSelectedProductSpecs,
  specs,
  setSpecs
}: {
  openModalCategory: string | null;
  setOpenModalCategory: (val: any) => void;
  selectedProductSpecs: any;
  setSelectedProductSpecs: (val: any) => void;
  specs: any;
  setSpecs: (val: any) => void;
}) {
  const {
    posts
  } = usePosts();
  useEffect(() => {
    if (posts.length > 0) {
      const newSpecs = {
        ...initialProductSpecifications
      };
      posts.forEach(post => {
        const category = post.customFields?.product_category?.toLowerCase();
        const title = post.title?.toLowerCase();
        let targetCategory = '';
        let targetIndex = -1;
        if (category === 'estructurales') {
          targetCategory = 'estructurales';
          targetIndex = estructuralesProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'perfileria') {
          targetCategory = 'perfileria';
          targetIndex = perfileriaProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'planos') {
          targetCategory = 'planos';
          targetIndex = planosProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'polineria') {
          targetCategory = 'polineria';
          targetIndex = polineriasProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'recubiertos') {
          targetCategory = 'recubiertos';
          targetIndex = recubiertosProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'solidos') {
          targetCategory = 'solidos';
          targetIndex = solidosProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'trefilados') {
          targetCategory = 'trefilados';
          targetIndex = trefiladosProducts.findIndex(p => p.title.toLowerCase() === title);
        } else if (category === 'tuberia') {
          targetCategory = 'tuberia';
          targetIndex = tuberiaProducts.findIndex(p => p.title.toLowerCase() === title);
        }
        if (targetCategory && targetIndex !== -1) {
          newSpecs[`${targetCategory}_${targetIndex}`] = {
            ...newSpecs[`${targetCategory}_${targetIndex}`],
            backgroundImage: post.customFields?.imagen || ''
          };
        }
      });
      setSpecs(newSpecs);
    }
  }, [posts, setSpecs]);
  return <>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {categories.map((category, i) => <Link key={i} to="#" data-index={i} onClick={e => {
        e.preventDefault();
        setOpenModalCategory(i === 0 ? 'estructurales' : i === 1 ? 'perfileria' : i === 2 ? 'planos' : i === 3 ? 'polineria' : i === 4 ? 'recubiertos' : i === 5 ? 'solidos' : i === 6 ? 'trefilados' : 'tuberia');
      }} className="group relative block aspect-square overflow-hidden rounded-md bg-muted border border-border shadow-md cursor-pointer hover:brightness-75">
            <img src={category.imageSrc} data-wvc-srcset={category.imageSrcset} data-wvc-sizes={category.imageSizes} alt={category.category_name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110 cursor-pointer hover:brightness-75" loading="lazy" />
            <div className="absolute inset-0 bg-primary/40 transition-colors duration-500 group-hover:bg-primary/70" />
            <div className="absolute inset-0 p-4 md:p-6 flex flex-col justify-end z-10">
              <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-white drop-shadow-lg font-default tracking-tight leading-tight">
                {category.category_name}
              </h3>
            </div>
          </Link>)}
      </div>

      <Dialog open={openModalCategory !== null} onOpenChange={open => !open && setOpenModalCategory(null)}>
        <DialogContent className="max-w-5xl w-[95vw] max-h-[90vh] overflow-y-auto bg-background border-border rounded-lg shadow-xl p-6 md:p-10 transition-opacity duration-300">
          <DialogHeader className="flex flex-row items-center justify-between mb-8">
            <DialogTitle className="text-3xl font-bold text-foreground font-default">
              {openModalCategory === 'recubiertos' ? 'Productos Recubiertos' : openModalCategory === 'polineria' ? 'Productos Polinería' : openModalCategory === 'planos' ? 'Productos Planos' : openModalCategory === 'estructurales' ? 'Productos Estructurales' : openModalCategory === 'solidos' ? 'Productos Sólidos' : openModalCategory === 'trefilados' ? 'Productos Trefilados' : openModalCategory === 'tuberia' ? 'Productos Tubería' : 'Productos de Perfilería'}
            </DialogTitle>
          </DialogHeader>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {(openModalCategory === 'recubiertos' ? recubiertosProducts : openModalCategory === 'polineria' ? polineriasProducts : openModalCategory === 'estructurales' ? estructuralesProducts : openModalCategory === 'perfileria' ? perfileriaProducts : openModalCategory === 'solidos' ? solidosProducts : openModalCategory === 'trefilados' ? trefiladosProducts : openModalCategory === 'tuberia' ? tuberiaProducts : planosProducts).map((product, idx) => <Card key={idx} data-index={idx} className="flex flex-col h-full border-border shadow-md rounded-md overflow-hidden bg-card">
                <div className="aspect-video relative overflow-hidden">
                  <img src={product.image} data-wvc-srcset={product.srcset} data-wvc-sizes={product.sizes} alt={product.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <CardContent className="p-6 flex-grow">
                  <h4 className="text-xl font-semibold mb-3 text-foreground font-default">
                    {product.title}
                  </h4>
                  <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                    {product.description}
                  </p>

                  <div className="mt-4 space-y-4">
                    <div className="border border-border rounded-md overflow-hidden">
                      
                    </div>

                    <Button onClick={() => window.open('https://wa.me/526149800517', '_blank')} className="w-full px-6 py-2 bg-primary text-white rounded-md hover:opacity-90 hover:shadow-md transition-all">
                      Cotizar
                    </Button>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={selectedProductSpecs !== null} onOpenChange={open => !open && setSelectedProductSpecs(null)}>
        <DialogContent className="max-w-4xl w-[90vw] bg-background border-border rounded-lg shadow-2xl p-0 overflow-hidden">
          {selectedProductSpecs && specs[`${selectedProductSpecs.category}_${selectedProductSpecs.index}`] && <div className="flex flex-col h-full max-h-[85vh]">
              <DialogHeader className="p-6 border-b border-border flex flex-row items-center justify-between">
                <DialogTitle className="text-2xl font-bold text-foreground font-default">
                  Especificaciones: {selectedProductSpecs.title}
                </DialogTitle>
              </DialogHeader>

              <div className="px-6 py-4 border-b border-border flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <label className="text-sm font-semibold text-foreground">Medidas y Pesos</label>
                </div>
              </div>
              
              <div className="flex-grow bg-muted flex items-center justify-center p-8 min-h-[400px] bg-contain bg-center bg-no-repeat !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/jijijijijij.png)]" style={{
            backgroundImage: specs[`${selectedProductSpecs.category}_${selectedProductSpecs.index}`].backgroundImage ? `url(${specs[`${selectedProductSpecs.category}_${selectedProductSpecs.index}`].backgroundImage})` : 'none'
          }}>
                {!specs[`${selectedProductSpecs.category}_${selectedProductSpecs.index}`].backgroundImage}
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </>;
}
export default function TicketsExperiencesGrid() {
  const [openModalCategory, setOpenModalCategory] = useState<'estructurales' | 'perfileria' | 'planos' | 'polineria' | 'recubiertos' | 'solidos' | 'trefilados' | 'tuberia' | null>(null);
  const [selectedProductSpecs, setSelectedProductSpecs] = useState<{
    title: string;
    index: number;
    category: string;
  } | null>(null);
  const [specs, setSpecs] = useState(initialProductSpecifications);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const wp_query_params = {
    post_type: "subproducto",
    per_page: 100
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="260155" id="productcategorygrid" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold mb-10 md:mb-14 font-default text-foreground tracking-tight">
            Soluciones en Acero
          </h2>
          
          <PostsProvider wp_query={{
          post_type: "subproducto",
          per_page: 100
        }}>
            <SpecificationsConsumer openModalCategory={openModalCategory} setOpenModalCategory={setOpenModalCategory} selectedProductSpecs={selectedProductSpecs} setSelectedProductSpecs={setSelectedProductSpecs} specs={specs} setSpecs={setSpecs} />
          </PostsProvider>
        </div>
      </div>
    </section>;
}